import { Carousel } from '@arco-design/mobile-react-serial-i18n';
import { Pagination } from '@byted/serial-components-i18n';
import Footer, { FooterTheme } from '@components/footer';
import Loading from '@components/loading';
import MobileHeader from '@components/mobile-header';
import { HeaderTheme } from '@constants/enum';
import { useTranslation } from '@ies/intl-react-plugin';
import React from 'react';
import { PAGE_COUNT, useCopyrightReq } from '../pc/hook';
import { useHistory } from 'react-router-dom';
import PublishHouseLogo1 from '../../../static/images/publish-house-logo1.png';
import PublishHouseLogo2 from '../../../static/images/publish-house-logo2.png';
import PublishHouseLogo3 from '../../../static/images/publish-house-logo3.png';
import PublishHouseLogo4 from '../../../static/images/publish-house-logo4.png';
import PublishHouseLogo5 from '../../../static/images/publish-house-logo5.png';
import PublishHouseLogo6 from '../../../static/images/publish-house-logo6.png';
import { Tea } from '@utils/tea';

import './index.less';

export default function Copyright() {
    const { t } = useTranslation();

    const history = useHistory();

    const {
        list: copyrightData,
        listLoading,
        pageIndex,
        initLoading,
        getList,
        total,
        banner: bannerData,
    } = useCopyrightReq();

    const handlePageChange = (index: number) => {
        if (index - 1 === pageIndex) {
            return;
        }
        getList(index - 1);
    };

    const goBack = () => {
        if (history.length > 1) {
            history.goBack();
            return;
        }

        history.replace(`/`);
    };

    const handlePurchase = (bookName: string, link: string) => {
        Tea('click_publishing_detail_purchase', {
            book_name: bookName,
        });
        window.location.href = link;
    };

    const renderContent = () => {
        return (
            <div className="copyright-h5-container">
                <div className="copyright-h5-back">
                    <div className="copyright-h5-back-icon" onClick={goBack} />
                    <div className="copyright-h5-back-name">{t('publishing_module_name')}</div>
                </div>
                {bannerData.length > 0 && (
                    <div className="copyright-h5-banner-container">
                        <Carousel className="copyright-h5-banner" autoPlay>
                            {bannerData?.map((item, index) => (
                                <div
                                    className="carousel-wrapper"
                                    key={index}
                                    onClick={() => (window.location.href = item.link)}
                                >
                                    <div className="carousel-wrapper-center">
                                        <img src={item.uri} />
                                    </div>
                                </div>
                            ))}
                        </Carousel>
                    </div>
                )}
                <div className="copyright-h5-content">
                    {copyrightData.map((item, index) => {
                        return (
                            <div className="copyright-h5-content-item" key={item.book_name}>
                                <div className="copyright-h5-content-item-cover-container">
                                    <span className="copyright-h5-content-item-cover-line" />
                                    <img className="copyright-h5-content-item-cover" src={item.book_cover} />
                                </div>
                                <div className="copyright-h5-content-item-detail">
                                    <div className="copyright-h5-content-item-detail-header">
                                        <div className="copyright-h5-content-item-detail-header-bookname">
                                            {item.book_name}
                                        </div>
                                        {!!Number(item.is_hot) && (
                                            <div className="copyright-h5-content-item-detail-header-hot" />
                                        )}
                                    </div>
                                    <div className="copyright-h5-content-item-detail-author">
                                        <div className="copyright-h5-content-item-detail-author-avatar-container">
                                            <img
                                                className="copyright-h5-content-item-detail-author-avatar"
                                                src={item.author_avatar}
                                            />
                                        </div>

                                        <div className="copyright-h5-content-item-detail-author-name">
                                            {item.author_name}
                                        </div>
                                    </div>
                                    <div className="copyright-h5-content-item-detail-introduction">
                                        {item.book_introduction}
                                    </div>
                                    <div className="copyright-h5-content-item-detail-footer">
                                        <div className="copyright-h5-content-item-detail-footer-publish">
                                            <img
                                                className="copyright-h5-content-item-detail-footer-publish-logo"
                                                src={item.publish_house_logo}
                                            />
                                            <div className="copyright-h5-content-item-detail-footer-publish-divider" />
                                            <div className="copyright-h5-content-item-detail-footer-publish-status">
                                                {item.has_published}
                                            </div>
                                        </div>
                                        {item.purchase_link.length > 3 && (
                                            <div
                                                className="copyright-h5-content-item-detail-footer-purchase"
                                                onClick={() => handlePurchase(item.book_name, item.purchase_link)}
                                            >
                                                <div>{t('purchase_published_book')}</div>
                                                <div className="copyright-h5-content-item-detail-footer-purchase-icon" />
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                        );
                    })}
                </div>
                {total > PAGE_COUNT && (
                    <Pagination
                        className="copyright-h5-pagination"
                        total={total}
                        pageSize={PAGE_COUNT}
                        current={pageIndex + 1}
                        onChange={handlePageChange}
                    />
                )}
                <div className="copyright-h5-publish-logo-container">
                    <div className="copyright-h5-publish-logo first">
                        <img className="copyright-h5-publish-logo-item" src={PublishHouseLogo1} />
                        <img className="copyright-h5-publish-logo-item" src={PublishHouseLogo2} />
                        <img className="copyright-h5-publish-logo-item" src={PublishHouseLogo3} />
                        <img className="copyright-h5-publish-logo-item" src={PublishHouseLogo4} />
                        <img className="copyright-h5-publish-logo-item" src={PublishHouseLogo5} />
                        <img className="copyright-h5-publish-logo-item" src={PublishHouseLogo6} />
                    </div>
                    <div className="copyright-h5-publish-logo second">
                        <img className="copyright-h5-publish-logo-item" src={PublishHouseLogo1} />
                        <img className="copyright-h5-publish-logo-item" src={PublishHouseLogo2} />
                        <img className="copyright-h5-publish-logo-item" src={PublishHouseLogo3} />
                        <img className="copyright-h5-publish-logo-item" src={PublishHouseLogo4} />
                        <img className="copyright-h5-publish-logo-item" src={PublishHouseLogo5} />
                        <img className="copyright-h5-publish-logo-item" src={PublishHouseLogo6} />
                    </div>
                </div>
            </div>
        );
    };
    return (
        <div className="copyright-h5">
            <MobileHeader />
            {initLoading ? <Loading /> : renderContent()}
            <Footer theme={FooterTheme.White} />
        </div>
    );
}
